export interface ProductDetailsWebEntity {
  productId: string;
  productName: string;
  daoLocationKey: string;
  segment: string;
  productKeyMapping: boolean;
  keyValueData: any;
  shouldVisitIfNoService: boolean;
}
